import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { IoMdCloudDone } from "react-icons/io";
import { BiError } from "react-icons/bi";

const LoadingSuccessErrorDialog = ({
  message,
  closeSuccessErrorMsg,
  isLoading,
  loadingText,
}) => {
  const isSuccess = message?.for === "success";

  return (
    <Dialog
      open={true}
      onClose={!isLoading ? closeSuccessErrorMsg : undefined}
      maxWidth="xs"
      fullWidth
    >
      <Box sx={{ position: "relative", p: 2 }}>
        {/* Close button - only show when not loading */}
        {!isLoading && (
          <IconButton
            onClick={closeSuccessErrorMsg}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "grey.500",
            }}
          >
            <CloseIcon />
          </IconButton>
        )}

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              pt: 2,
            }}
          >
            {/* Loading State */}
            {isLoading ? (
              <>
                <CircularProgress
                  size={48}
                  sx={{
                    mb: 2,
                    color: "#00AB4E",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{
                    color: "text.primary",
                    fontWeight: 500,
                  }}
                >
                  {loadingText}
                </Typography>
              </>
            ) : (
              <>
                {/* Success/Error Icon */}
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: isSuccess
                      ? "rgba(0, 171, 78, 0.1)"
                      : "rgba(211, 47, 47, 0.1)",
                    mb: 2,
                  }}
                >
                  {isSuccess ? (
                    <IoMdCloudDone size={32} style={{ color: "#00AB4E" }} />
                  ) : (
                    <BiError size={32} style={{ color: "#d32f2f" }} />
                  )}
                </Box>

                {/* Success/Error Message */}
                <Typography
                  variant="body1"
                  align="center"
                  sx={{
                    color: isSuccess ? "#00AB4E" : "#d32f2f",
                    fontWeight: 500,
                  }}
                >
                  {message.msg}
                </Typography>
              </>
            )}
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default LoadingSuccessErrorDialog;
